import client from "../client";

export interface GetChaotchaResponse {
  id?: string;
  image?: string;
}

export default function API(): Promise<GetChaotchaResponse> {
  return client.get(`auth/get_chaptcha`).then((response) => response.data);
}
